import thunk from 'redux-thunk';

function createRealThunks(logic, input, dispatch, getState) {
  var get = function get(key) {
    return key ? logic.selectors[key](getState()) : logic.selector(getState());
  };

  var fetch = function fetch() {
    var results = {};
    var keys = Array.isArray(arguments[0]) ? arguments[0] : arguments;

    for (var i = 0; i < keys.length; i++) {
      results[keys[i]] = get(keys[i]);
    }

    return results;
  };

  return input.thunks(Object.assign({}, logic, {
    dispatch: dispatch,
    getState: getState,
    get: get,
    fetch: fetch
  }));
}

export default {
  name: 'thunk',
  events: {
    beforeReduxStore: function beforeReduxStore(options) {
      options.middleware.push(thunk);
    }
  },
  buildOrder: {
    thunks: {
      after: 'actionCreators'
    }
  },
  buildSteps: {
    thunks: function thunks(logic, input) {
      if (!input.thunks) {
        return;
      }

      var realThunks = void 0;
      var thunkKeys = Object.keys(input.thunks(logic));
      var thunkFunctions = {};
      thunkKeys.forEach(function (thunkKey) {
        thunkFunctions[thunkKey] = function () {
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return function (dispatch, getState) {
            var _realThunks;

            if (!realThunks) {
              realThunks = createRealThunks(logic, input, dispatch, getState);
            }

            return (_realThunks = realThunks)[thunkKey].apply(_realThunks, args);
          };
        };
      });
      logic.actionCreators = Object.assign({}, logic.actionCreators, thunkFunctions);
    }
  }
};